import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { checkVersionRequest } from 'store/version/version.actions'
import { selectCurrentUser } from 'store/users/users.selectors'

import BillingHeader from 'components/organisms/BillingHeader/BillingHeader'
import ReportForm from 'components/molecules/Billing/ReportForm'
import PlugBilling from 'components/molecules/Billing/PlugBilling'
import Balance from 'components/molecules/Billing/balance'

export const BillingPage: React.FC = () => {
  const dispatch = useDispatch()
  const currentUser = useSelector(selectCurrentUser)

  const userIsCustomerAdmin = currentUser?.features?.subrole === 'customer-admin'

  useEffect(() => {
    dispatch(checkVersionRequest())
  }, [dispatch])

  return (
    <div className="container page-content d-flex flex-column flex-grow-1">
      <BillingHeader />

      {userIsCustomerAdmin ? (
        <>
          <Balance />
          <ReportForm />
        </>
      ) : (
        <PlugBilling />
      )}
    </div>
  )
}

export default BillingPage
